import { Component, OnInit, ViewChild, Inject, Renderer2 } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import 'rxjs/add/observable/of';
import { OrderService } from '../../../services/order/order.service';
import { Address } from '../../../interfaces/address';
import { TokenStorage } from 'src/app/auth/token.storage';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-allorderdetails',
  templateUrl: './allorderdetails.component.html',
  styleUrls: ['./allorderdetails.component.scss']
})
export class AllorderdetailsComponent implements OnInit {
  columnsToDisplay = [
    'SKU',
    'Model',
    'Category',
    'Quantity',
    'Serial',
    'packageCapacity'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  orderId: number;
  receiverName: string;
  orderState: string;
  invoiceNumber: string;
  orderCreatedTimestamp: string;
  deliveryDatetime: string;
  totalweightCapacity: number;
  totalvolumeCapacity: number;
  dispatchDate: string;
  actualDeliveryDate: string;
  houseNumber: string;
  area: string;
  city: string;
  pincode: string;
  zone: string;
  zoom: number = 13;
  lat: number = 18.533989;
  lng: number = 73.825592;
  order: any;
  productDataArray = new MatTableDataSource;
  orderNumber: string;
  ordersByTripIdArray = [];
  productArrayInSelectedOrder = [];
  productInputDisplayArray = [];
  public receiverAddress: Address;
  public originAddress: Address;
  receiverPhoneNo: any;
  image1: string;
  image2: string;
  image3: string;
  image4: string;
  isImage1Available: boolean = false;
  isImage2Available: boolean = false;
  isImage3Available: boolean = false;
  isImage4Available: boolean = false;
  customCollapsedHeight: string = '35px';
  customExpandedHeight: string = '35px';
  width: string;
  height: string;
  driverName: string;
  esignImage: string;
  isesignImageAvailable: boolean = false;
  deliveryFailureReason: string;
  customerFeedback: string;
  score: number = 0;
  // forDisplay:boolean = true;
  range = [1, 2, 3, 4, 5]
  isZoneOfOriginAddress: boolean = false;
  podToShow: boolean = false;
  podList: Array<string> = [];
  isTenantDiag: boolean = false;
  oStateTitle: string;
  isOrderLoading: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public orderService: OrderService,
    public dialog: MatDialog,
    private token: TokenStorage


  ) {
  }

  ngOnInit() {
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;

      this.columnsToDisplay = [
        'SKU',
        'Category',
        'Quantity',
      ]

    }
    else
      this.isTenantDiag = false;
    if (this.data.component == 'orderReport') {
      console.log(this.data.component)
      this.orderService.getOrderDetails(this.data.orderId).subscribe(orderData => {
        console.log(orderData)
        this.data.data = orderData;
        this.order = orderData.orderInfo;
        this.orderDetails();
      }, Error => {
        console.log(Error)
      });
    }
    else {
      this.order = this.data.data.orderInfo;
      this.orderDetails();
    }
  }

  orderDetails() {
    if (this.token.getTenant() === 'kohinoor-reta-prod')
      this.podToShow = true;
    if (this.token.getTenant() === 'bajaj-reta-prod' || this.token.getTenant() === 'bajaj-reta-test')
      this.isZoneOfOriginAddress = true;
    console.log("order details", this.data.data);
    this.orderId = this.order.orderUniqueId;
    this.receiverName = this.order.receiverName;
    this.receiverAddress = this.order.destinationAddress;
    this.receiverPhoneNo = this.order.receiverPhoneNumber;
    this.originAddress = this.order.originAddress;
    if (this.isZoneOfOriginAddress)
      this.zone = this.order.originAddress.zone;
    else
      if (this.order.destinationAddress)
        this.zone = this.order.destinationAddress.zone;
    if (this.isTenantDiag) {
      this.zone = this.order.originAddress.area ? this.order.originAddress.area : null;
    }
    this.orderState = (this.order.oState).slice(12);
    this.oStateTitle = this.orderState;
    if (this.isTenantDiag && this.orderState == 'DELIVERED' && this.data.component == 'pickup')
      this.oStateTitle = 'PICKED'
    else if (this.isTenantDiag && this.orderState == 'DELIVERED')
      this.oStateTitle = 'VISITED'
    this.invoiceNumber = this.order.orderInvoiceNumber;
    this.originAddress = this.order.originAddress;
    this.orderCreatedTimestamp = this.order.orderCreatedDateTime;
    this.deliveryDatetime = this.order.deliveryETADateTime;
    this.totalvolumeCapacity = this.order.totalVolume;
    this.totalweightCapacity = this.order.totalWeight;
    this.dispatchDate = this.order.deliveryETADateTime;
    if (this.orderState == 'DELIVERED' || this.orderState == 'FAILED' || this.orderState == 'SCHEDULED' || this.orderState == 'IN_TRANSIT') {
      this.isOrderLoading = true;
      this.orderService.getOrder(this.orderId).subscribe(res => {
        console.log("res", res)
        this.actualDeliveryDate = res.orderInfo.actualDeliveryDatetime;
        if (res.orderInfo.trip) {
          let lastName = "";
          if (res.orderInfo.trip.driver) {
            if (res.orderInfo.trip.driver.lastName) {
              lastName = res.orderInfo.trip.driver.lastName
            }
            if (res.orderInfo.trip.driver.phoneNumber1)
              this.driverName = res.orderInfo.trip.driver.firstName + " " + lastName + " " + "(" + res.orderInfo.trip.driver.phoneNumber1 + ")";
            else
              this.driverName = res.orderInfo.trip.driver.firstName + " " + lastName;
          }
          this.isOrderLoading = false;
        }
      }, Error => {
        this.isOrderLoading = false;
      })
    }
    // this.orderDataArray.data = [this.order];
    // this.getAllProductsFromOrdersInTrip();
    this.productDataArray.data = this.data.data.prodQList;

    if (this.orderState === "DELIVERED") {
      this.getPODImageLinks();
    }

    if (this.orderState === "FAILED") {
      this.orderService.getJobDetails(this.orderId).subscribe(jobRes => {
        console.log(jobRes);
        this.deliveryFailureReason = jobRes.reason;
      });
    }


    if (this.orderState === "DELIVERED") {
      this.orderService.getCustomerFeedack(this.orderId).subscribe(feedback => {
        console.log("customer feedback for order " + " " + this.orderId + " ", feedback);
        if (feedback) {
          this.customerFeedback = feedback.feedbackComments;
          let rating = feedback.feedbackRating.substr(feedback.feedbackRating.length - 1);
          this.score = rating;
        }
      });
    }
  }

  public isMarked = (index) => {
    if (this.score >= index + 1) {
      return 'fa-star';
    }
    else {
      return 'fa-star-o';
    }
  }




  getPODImageLinks() {
    console.log(this.orderId);
    this.orderService.podImageData(this.orderId).subscribe(res => {
      this.podList = res;
      this.orderService.eSignImage(this.orderId).subscribe(esign => {
        if (esign)
          this.podList.push(esign[0]);
      });
    });
  }

  openImage(event) {
    const dialogR = this.dialog.open(ImagePopup, {
      data: event.srcElement.currentSrc
    });
    dialogR.updatePosition({
      top: '74px'
    });
  }
}

//image popup component for POD
@Component({
  selector: 'image-popup',
  template: `
  <div>
  <button class="float-right" mat-dialog-close style="color:blue;">
    <mat-icon>close</mat-icon>
  </button>
</div>
  <div style="padding:20px;">
  <div class="col-10">
  <img id="geeks" [src]="domSanitize(imagePath)" class="imagepreview" style="width:500px;height:500px"/>
  <p class="m-1 text-center">
    <img class="m-3 m-r-20" src="assets/images/zoom-in.png" matTooltip="Zoom In" (click)="zoomin()" style="width:25px"/>
    <img class="m-3 m-r-20" src="assets/images/zoom-out.png" matTooltip="Zoom Out" (click)="zoomout()" style="width:25px"/>
    <img class="m-3 m-r-20" src="assets/images/rotate-right.png" matTooltip="Rotate Right" (click)="rotateImage('right')" style="width:25px"/>
    <img class="m-3 m-r-20" src="assets/images/rotate-left.png" matTooltip="Rotate Left" (click)="rotateImage('left')" style="width:25px"/>
  </p>
</div>
  </div>
  `,
  styles: ['button:focus {outline:0;}']

})


export class ImagePopup implements OnInit {
  constructor(
    public dialogR: MatDialogRef<ImagePopup>,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }
  imagePath: string;
  extension: string;
  angle = 0;
  zoomClick = 0;
  ngOnInit() {
    this.imagePath = this.data;
  }


  rotateImage(direction) {
    this.angle += direction == 'left' ? -90 : 90;
    this.renderer.setStyle(document.querySelector('.imagepreview'), 'transform', `rotate(${this.angle}deg)`);
  }

  zoomin() {
    if (this.zoomClick < 5) {
      var GFG = document.getElementById("geeks");
      var currHeight = GFG.clientHeight;
      var currWidth = GFG.clientWidth;
      GFG.style.height = (currHeight + 20) + "px";
      GFG.style.width = (currWidth + 20) + "px";
      this.zoomClick++;
    }
  }

  zoomout() {
    if (this.zoomClick > -4) {
      var GFG = document.getElementById("geeks");
      var currHeight = GFG.clientHeight;
      var currWidth = GFG.clientWidth;
      GFG.style.height = (currHeight - 20) + "px";
      GFG.style.width = (currWidth - 20) + "px";
      this.zoomClick--;
    }

  }
  domSanitize(src) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(src)
  }

}